import { UserReducers } from './../user/reducers/user.reducer';
import { ActionReducerMap, MetaReducer, Action } from "@ngrx/store";
import { storeFreeze } from "ngrx-store-freeze";
import { environment } from "src/environments/environment";
import { IAppState } from "../state/app.state";
import { ClientReducer } from "../client/reducers/client.reducers";
import { GeneralSelectionReducer } from "../general-selection/reducers/general-selection.reducers";
import { HoldingsReducer } from "../holdings/reducers/holdings.reducer";
import { ModelPortfoliosReducer } from "../model-portfolios/reducers/model-portfolios.reducer";
import { performanceReducer } from '../performance/reducers/performance.reducer';
import { portfoliosReducer } from "../portfolios/reducers/portfolios.reducer";
import { SystemReducer } from "../system/reducers/system.reducer";
import { UtilitiesReducer } from "../utilities/reducers/utilities.reducers";
import { TradingReducer } from "../order/reducers/trading.reducers";
import { PlannedPortfoliosReducer } from "src/app/store/planned-portfolios/reducers/planned-portfolios.reducer";
import { TempPlannedPortfoliosReducer } from "src/app/store/planned-portfolios/reducers/temp-planned-portfolios.reducer";
import { GlobalNotificationReducers } from "src/app/store/global-notification/reducers/global-notification.reducer";

export type Reducer<T> = (state: T, action: Action) => T;

export const appReducer: ActionReducerMap<Reducer<IAppState>> = {
  user: UserReducers,
  client: ClientReducer,
  generalSelection: GeneralSelectionReducer,
  holdings: HoldingsReducer,
  modelPortfolios: ModelPortfoliosReducer,
  performance: performanceReducer,
  portfolios: portfoliosReducer,
  system: SystemReducer,
  tradings: TradingReducer,
  countries: UtilitiesReducer,
  plannedPortfolios: PlannedPortfoliosReducer,
  tempPlannedPortfolios: TempPlannedPortfoliosReducer,
  globalNotification: GlobalNotificationReducers,
};

export const appMetaReducers: MetaReducer<Reducer<IAppState>>[] = !environment.production
  ? [storeFreeze]
  : [];
